import { apiClient } from "../api/apiClient";

const startPaymentTPay = (orderId, idempotencyKey) => {
    return apiClient.post(
        `/orders/${orderId}/payments/tpay`,
        {},
        {
            headers: {
                "Content-Type": "application/json",
                ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
            },
        }
    );
};

const downloadTicket = (ticketId, token) => {
    return apiClient.get(`/tickets/${ticketId}/download`, {
        params: { token },
        responseType: "blob",
    });
};

const create = ({ eventId, buyer, items, freeQuantity, participants, idempotencyKey }) =>
    apiClient.post(`/orders`, {
        eventId,
        buyer,
        items,
        freeQuantity,
        participants,
        idempotencyKey,
    }, {
        headers: {
            "Content-Type": "application/json",
            "X-Idempotency-Key": idempotencyKey
        }
    }).then(r => r.data);

export default {
    startPaymentTPay,
    downloadTicket,
    create
};
